<script>
export default {
  name: 'ReportTableTooltipIcon',
  functional: true,
  props: {
    message: {
      type: String,
      required: true,
    },
    placement: {
      type: String,
      default: 'auto bottom',
    },
    type: {
      type: String,
      default: 'info',
    },
    dataHtml: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Number,
      default: 16,
    },
  },
  render(createElement, context) {
    if (context.props.message.length === 0) {
      return;
    }

    const { message, placement, type, dataHtml, size } = context.props;
    let iconClasses = ['a-tooltip hi', `hi-${size}`];

    if (type === 'warning') {
      iconClasses = iconClasses.concat(['hi-important', 'text-warning']);
    } else if (type === 'danger') {
      iconClasses = iconClasses.concat(['hi-important', 'text-danger']);
    } else {
      iconClasses = iconClasses.concat(['hi-info', 'text-muted']);
    }

    return createElement(
      'i',
      Object.assign(context.data, {
        class: iconClasses,
        attrs: {
          title: message,
          'data-original-title': message,
          'data-html': dataHtml,
        },
        directives: [
          {
            name: 'tooltip',
            value: {
              placement,
            },
          },
        ],
      }),
    );
  },
};
</script>
